<template>
	<v-card class="">
		<v-card-subtitle v-if="sample">
			<h2 class="mb-0">{{ sample.name }}</h2>
		</v-card-subtitle>
		<v-card-text v-if="sample.bean">
			<h2 class="mb-0">{{ sample.bean.name }}</h2>
			<div class="text-right">
				<div class="text-h4 font-weight-bold primary--text">{{ totalScore }} /105</div>
			</div>
			<v-form ref="form" v-model="valid">
				<v-row class="px-0">
					<v-col cols="12" md="6">
						<div class="mb-2 align-center d-flex justify-space-between">
							<div>
								<div class="d-inline h-100">干香:</div>
								<span class="score-value ml-2">{{ score.aroma }}</span>
							</div>
							<div>
								<v-btn icon small @click="showFlavor1 = !showFlavor1" outlined color="primary">
									<v-icon>$plus</v-icon>
								</v-btn>
								<v-btn small icon @click="showNotes1 = !showNotes1" outlined color="primary">
									<v-icon>$note</v-icon>
								</v-btn>
							</div>
						</div>
						<ScoreSlider v-model="score.aroma" />
					</v-col>
					<v-col cols="12" md="6">
						<div class="mb-2">
							湿香:
							<span class="score-value ml-2">{{ score.fragrance }}</span>
						</div>
						<ScoreSlider v-model="score.fragrance" />
					</v-col>
					<v-col cols="12" v-if="showFlavor1">
						<score-tags v-model:tags="score.aroma_tags" />
					</v-col>
					<v-col cols="12" v-if="showNotes1">
						<v-textarea v-model="score.aroma_notes" label="香气备注" rows="4" auto-grow />
					</v-col>
				</v-row>
				<v-divider class="my-4" />
				<v-row>
					<v-col cols="12" md="6">
						<div class="mb-2 align-center d-flex justify-space-between">
							<div>
								风味:
								<span class="score-value ml-2">{{ score.flavor }}</span>
							</div>
							<div>
								<v-btn small @click="showFlavor2 = !showFlavor2" icon outlined color="primary">
									<v-icon>$plus</v-icon>
								</v-btn>
								<v-btn small @click="showNotes2 = !showNotes2" icon outlined color="primary">
									<v-icon>$note</v-icon>
								</v-btn>
							</div>
						</div>
						<ScoreSlider v-model="score.flavor" />
					</v-col>
					<v-col cols="12" md="6">
						<div class="mb-2">
							余韵:
							<span class="score-value ml-2">{{ score.aftertaste }}</span>
						</div>
						<ScoreSlider v-model="score.aftertaste" />
					</v-col>

					<v-col cols="12" v-if="showFlavor2">
						<score-tags v-model:tags="score.flavor_tags" />
					</v-col>
					<v-col cols="12">
						<div class="mb-1">
							主要味道
							<span class="text-caption text-medium-emphasis ml-1">（必选 2 个）</span>
						</div>
						<v-input
							v-model="score.primary_tastes"
							:rules="primaryTastesRules"
							:error-messages="errors.primary_tastes"
							hide-details="auto"
						>
							<div class="d-flex flex-row flex-wrap">
								<v-checkbox
									v-for="opt in primaryTastes"
									:key="opt.value"
									:label="opt.label"
									:value="opt.value"
									v-model="score.primary_tastes"
									:disabled="isPrimaryTasteDisabled(opt.value)"
									hide-details
									class="mr-2"
								/>
							</div>
						</v-input>
					</v-col>
					<v-col cols="12" v-if="showNotes2">
						<v-textarea v-model="score.flavor_notes" label="风味备注" rows="4" auto-grow />
					</v-col>
				</v-row>

				<v-divider class="my-4" />
				<v-row>
					<v-col cols="12" md="6">
						<div class="mb-2">
							酸质:
							<span class="score-value ml-2">{{ score.acidity }}</span>
						</div>
						<ScoreSlider v-model="score.acidity" />
					</v-col>
					<v-col cols="12" md="6">
						<div class="mb-2">
							甜感:
							<span class="score-value ml-2">{{ score.sweetness }}</span>
						</div>
						<ScoreSlider v-model="score.sweetness" />
					</v-col>
				</v-row>
				<v-divider class="my-4" />
				<v-row>
					<v-col cols="12" md="6">
						<div class="mb-2 align-center d-flex justify-space-between">
							<div>
								口感:
								<span class="score-value ml-2">{{ score.body }}</span>
							</div>

							<div>
								<v-btn small icon @click="showBodyOptions = !showBodyOptions" outlined color="primary">
									<v-icon>$plus</v-icon>
								</v-btn>
							</div>
						</div>
						<ScoreSlider v-model="score.body" />
					</v-col>
					<v-col cols="12" md="6" v-if="showBodyOptions">
						<score-body-tags v-model:tags="score.body_tags" />
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions class="d-flex justify-space-around">
			<slot name="actions" :object="score" :totalScore="totalScore" :valid="valid">
				<v-btn color="primary" :disabled="!valid" @click="submitScore">提交</v-btn>
			</slot>
		</v-card-actions>
	</v-card>
</template>

<script>
import ScoreBodyTags from './ScoreBodyTags.vue'
import ScoreTags from './ScoreFlavorTags.vue'
import ScoreSlider from './ScoreSlider.vue'

export default {
	name: 'ScoreForm',
	components: {
		ScoreSlider,
		ScoreTags,
		ScoreBodyTags
	},
	props: {
		sample: {
			type: Object,
			default: null
		},
		initialScore: {
			type: Object,
			default: () => ({})
		},
		errors: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			valid: false,
			score: {
				aroma: 8,
				fragrance: 8,
				aroma_tags: [],
				aroma_notes: '',
				flavor: 8,
				aftertaste: 8,
				flavor_tags: [],
				flavor_notes: '',
				acidity: 8,
				sweetness: 8,
				body: 8,
				body_tags: [],
				primary_tastes: []
			},
			primaryTastes: [
				{ label: '咸', value: 'salty' },
				{ label: '酸', value: 'acidic' },
				{ label: '甜', value: 'sweet' },
				{ label: '苦', value: 'bitter' },
				{ label: '鲜味', value: 'umami' }
			],
			primaryTastesRules: [
				(v) => (Array.isArray(v) && v.length === 2) || '主要味道必须选择 2 个'
			],
			showFlavor1: false,
			showFlavor2: false,
			showNotes1: false,
			showNotes2: false,
			showBodyOptions: false
		}
	},
	computed: {
		// 计算总分：SCA杯测评分标准，7项各15分，总分最高105分
		totalScore() {
			const scores = [
				this.score.aroma || 0,
				this.score.fragrance || 0,
				this.score.flavor || 0,
				this.score.aftertaste || 0,
				this.score.acidity || 0,
				this.score.sweetness || 0,
				this.score.body || 0
			]
			return scores.reduce((sum, val) => sum + Number(val), 0)
		}
	},
	created() {
		if (this.initialScore && Object.keys(this.initialScore).length > 0) {
			Object.assign(this.score, this.initialScore)
		} else {
			Object.assign(this.score, {
				aroma: 10,
				fragrance: 10,
				aroma_tags: [],
				aroma_notes: '',
				flavor: 10,
				aftertaste: 10,
				flavor_tags: [],
				flavor_notes: '',
				acidity: 10,
				sweetness: 10,
				body: 10,
				body_tags: [],
				primary_tastes: []
			})
		}
		if (!Array.isArray(this.score.primary_tastes)) {
			this.score.primary_tastes = []
		}
	},
	methods: {
		isPrimaryTasteDisabled(value) {
			const selected = this.score.primary_tastes || []
			return selected.length >= 2 && !selected.includes(value)
		},
		async validate() {
			const result = await this.$refs.form?.validate()
			return !!result?.valid
		},
		async submitScore() {
			if (!(await this.validate())) return
			this.$emit('submit', {
				score: this.score,
				totalScore: this.totalScore
			})
		}
	}
}
</script>

<style scoped>
.sample-card {
	margin-bottom: 1rem;
}
.score-value {
	font-weight: bolder;
	font-size: 1.3rem;
}
@media print {
	/* 打印友好：移除操作按钮 */
	button,
	.v-btn {
		display: none !important;
	}
	.v-expansion-panels .v-expansion-panel__header {
		display: block !important;
	}
}
</style>
